import { Facet } from '@ms/items-view/lib/private/models/Facet';
import { IItemCacheThunkAction } from '@ms/items-view/lib/private/store/actions/ItemCacheActions';

/**
 * @public
 */
export interface IEnsureAuthToken {
  (scopes: string[], endpoint: string): Promise<string | undefined>;
}

/**
 * @internal
 */
export interface IEnsureAuthTokenWithAction {
  (scopes: string[], endpoint: string): IItemCacheThunkAction<Promise<string | undefined>>;
}

/**
 * @public
 */
export const graphDataSourceConfigurationFacet: Facet<{
  ensureAuthToken: IEnsureAuthToken;
  ensureAuthTokenWithAction?: IEnsureAuthTokenWithAction;
}> = new Facet('graphDataSourceConfiguration');
